export default {
  unavailable: {
    title: 'Dieser Service wird von Foodamigos betrieben',
    description:
      'Der Flyer- und Stickerdruck ist ein Service des Foodamigos-Teams und für Partner-Konten nicht verfügbar.',
  },
};
